import * as amplitude from "@amplitude/analytics-browser";

export function trackEvent(eventName, eventProperties = {}) {
  amplitude.track(eventName, eventProperties);
}